<!--
  Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<h1 class="title">Manage Engine Attributes</h1>
<span class="header-spacing"></span>
<button mat-raised-button color="primary" id="reset-button" class="reset-button"
        (click)="resetFilter()">
  Reset Filters
</button>
<fab-loading-spinner color="primary" *ngIf="showSpinner" id="loading-spinner"></fab-loading-spinner>

<div>
  <mat-form-field appearance="fill"
                  (click)="resetText(engineFamily)">
    <mat-label>Engine Family</mat-label>
    <input type="text" id="engine-family-input"
           [placeholder]="ALL"
           matInput
           [formControl]="engineFamily.model"
           [matAutocomplete]="autoEngineFamily"/>
    <mat-autocomplete #autoEngineFamily="matAutocomplete" (optionSelected)="onChangeEngineFamily()">
      <mat-option *ngFor="let engineFamily of this.engineFamily.filteredOptions | async"
                  [value]="engineFamily">{{engineFamily}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <button mat-raised-button color="primary" class="edit-button"
          [disabled]="engineFamily.selectedOptions === ALL || engineFamily.selectedOptions === '%'"
          (click)="openDialog('Engine Family', engineFamily.selectedOptions, engineFamily.searchAttribute.toString())">
    Edit
  </button>

  <mat-form-field appearance="fill"
                  (click)="resetText(engineRPO)">
    <mat-label>Engine RPO</mat-label>
    <input type="text" id="engine-rpo-input"
           [placeholder]="ALL"
           matInput
           [formControl]="engineRPO.model"
           [matAutocomplete]="autoEngineRpo"/>
    <mat-autocomplete #autoEngineRpo="matAutocomplete" (optionSelected)="onChangeEngineRPO()">
      <mat-option *ngFor="let engineRPO of engineRPO.filteredOptions | async"
                  [value]="engineRPO">{{engineRPO}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <span class="spacing"></span>

  <mat-form-field appearance="fill"
                  (click)="resetText(batRPO)">
    <mat-label>Bat RPO</mat-label>
    <input type="text" id="bat-rpo-input"
           [placeholder]="ALL"
           matInput
           [formControl]="batRPO.model"
           [matAutocomplete]="autoBatRPO"/>
    <mat-autocomplete #autoBatRPO="matAutocomplete" (optionSelected)="onChangeBatRpo()">
      <mat-option *ngFor="let batRPO of this.batRPO.filteredOptions | async"
                  [value]="batRPO">{{batRPO}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <span class="spacing"></span>

  <mat-form-field appearance="fill"
                  (click)="resetText(boost)">
    <mat-label>Boost</mat-label>
    <input type="text" id="boost-input"
           [placeholder]="ALL"
           matInput
           [formControl]="boost.model"
           [matAutocomplete]="autoBoost"/>
    <mat-autocomplete #autoBoost="matAutocomplete" (optionSelected)="onChangeBoost()">
      <mat-option *ngFor="let boost of this.boost.filteredOptions | async"
                  [value]="boost">{{boost}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>

<div>
  <mat-form-field appearance="fill"
                  (click)="resetText(engineCam)">
    <mat-label>Engine Cam</mat-label>
    <input type="text" id="engine-cam-input"
           [placeholder]="ALL"
           matInput
           [formControl]="engineCam.model"
           [matAutocomplete]="autoEngineCam"/>
    <mat-autocomplete #autoEngineCam="matAutocomplete" (optionSelected)="onChangeEngineCam()">
      <mat-option *ngFor="let engineCam of this.engineCam.filteredOptions | async"
                  [value]="engineCam">{{engineCam}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <span class="spacing"></span>

  <mat-form-field appearance="fill"
                  (click)="resetText(engineDSP)">
    <mat-label>Engine Dsp</mat-label>
    <input type="text" id="engine-dsp-input"
           [placeholder]="ALL"
           matInput
           [formControl]="engineDSP.model"
           [matAutocomplete]="autoEngineDSP"/>
    <mat-autocomplete #autoEngineDSP="matAutocomplete" (optionSelected)="onChangeEngineDSP()">
      <mat-option *ngFor="let engineDsp of this.engineDSP.filteredOptions | async"
                  [value]="engineDsp">{{engineDsp}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <span class="spacing"></span>

  <mat-form-field appearance="fill"
                  (click)="resetText(engineCYL)">
    <mat-label>Engine Cyl</mat-label>
    <input type="text" id="engine-cyl-input"
           [placeholder]="ALL"
           matInput
           [formControl]="engineCYL.model"
           [matAutocomplete]="autoEngineCyl"/>
    <mat-autocomplete #autoEngineCyl="matAutocomplete" (optionSelected)="onChangeEngineCYL()">
      <mat-option *ngFor="let engineCyl of this.engineCYL.filteredOptions | async"
                  [value]="engineCyl">{{engineCyl}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <span class="spacing"></span>

  <mat-form-field appearance="fill"
                  (click)="resetText(enginePower)">
    <mat-label>Engine Power</mat-label>
    <input type="text" id="engine-power-input"
           [placeholder]="ALL"
           matInput
           [formControl]="enginePower.model"
           [matAutocomplete]="autoEnginePower"/>
    <mat-autocomplete #autoEnginePower="matAutocomplete" (optionSelected)="onChangeEnginePower()">
      <mat-option *ngFor="let enginePower of this.enginePower.filteredOptions | async"
                  [value]="enginePower">{{enginePower}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <button mat-raised-button color="primary" class="edit-button"
          [disabled]="enginePower.selectedOptions === ALL || enginePower.selectedOptions === '%'"
          (click)="openDialog('Engine Power', enginePower.selectedOptions, enginePower.searchAttribute.toString())">
    Edit
  </button>
</div>

<div>
  <mat-form-field appearance="fill"
                  (click)="resetText(engineTorque)">
    <mat-label>Engine Torque</mat-label>
    <input type="text" id="engine-torque-input"
           [placeholder]="ALL"
           matInput
           [formControl]="engineTorque.model"
           [matAutocomplete]="autoEngineTorque"/>
    <mat-autocomplete #autoEngineTorque="matAutocomplete" (optionSelected)="onChangeEngineTorque()">
      <mat-option *ngFor="let engineTorque of this.engineTorque.filteredOptions | async"
                  [value]="engineTorque">{{engineTorque}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <button mat-raised-button color="primary" class="edit-button"
          [disabled]="engineTorque.selectedOptions === ALL || engineTorque.selectedOptions === '%'"
          (click)="openDialog('Engine Torque', engineTorque.selectedOptions, engineTorque.searchAttribute.toString())">
    Edit
  </button>

  <mat-form-field appearance="fill"
                  (click)="resetText(vFuel)">
    <mat-label> VFuel</mat-label>
    <input type="text" id="vfuel-input"
           [placeholder]="ALL"
           matInput
           [formControl]="vFuel.model"
           [matAutocomplete]="autoVFuel"/>
    <mat-autocomplete #autoVFuel="matAutocomplete" (optionSelected)="onChangeVFuel()">
      <mat-option *ngFor="let vFuel of this.vFuel.filteredOptions | async"
                  [value]="vFuel">{{vFuel}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <span class="spacing"></span>

  <mat-form-field appearance="fill"
                  (click)="resetText(injection)">
    <mat-label>Injection</mat-label>
    <input type="text" id="injection-input"
           [placeholder]="ALL"
           matInput
           [formControl]="injection.model"
           [matAutocomplete]="autoInjection"/>
    <mat-autocomplete #autoInjection="matAutocomplete" (optionSelected)="onChangeInjection()">
      <mat-option *ngFor="let injection of this.injection.filteredOptions | async"
                  [value]="injection">{{injection}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <span class="spacing"></span>

</div>

